// google bot ips
// from https://developers.google.com/search/docs/advanced/crawling/verifying-googlebot
const googleBotIps = [
  "2001:4860:4801:10",
  "2001:4860:4801:11",
  "2001:4860:4801:12",
  "2001:4860:4801:13",
  "2001:4860:4801:14",
  "2001:4860:4801:15",
  "2001:4860:4801:16",
  "2001:4860:4801:17",
  "2001:4860:4801:18",
  "2001:4860:4801:19",
  "2001:4860:4801:20",
  "2001:4860:4801:21",
  "2001:4860:4801:22",
  "2001:4860:4801:23",
  "2001:4860:4801:24",
  "2001:4860:4801:25",
  "2001:4860:4801:2",
  "2001:4860:4801:26",
  "2001:4860:4801:27",
  "2001:4860:4801:28",
  "2001:4860:4801:29",
  "2001:4860:4801:2a",
  "2001:4860:4801:2b",
  "2001:4860:4801:2c",
  "2001:4860:4801:2d",
  "2001:4860:4801:2e",
  "2001:4860:4801:2f",
  "2001:4860:4801:30",
  "2001:4860:4801:31",
  "2001:4860:4801:32",
  "2001:4860:4801:33",
  "2001:4860:4801:34",
  "2001:4860:4801:35",
  "2001:4860:4801:3",
  "2001:4860:4801:36",
  "2001:4860:4801:37",
  "2001:4860:4801:38",
  "2001:4860:4801:39",
  "2001:4860:4801:3a",
  "2001:4860:4801:3b",
  "2001:4860:4801:40",
  "2001:4860:4801:41",
  "2001:4860:4801:42",
  "2001:4860:4801:43",
  "2001:4860:4801:44",
  "2001:4860:4801:45",
  "2001:4860:4801:46",
  "2001:4860:4801:47",
  "2001:4860:4801:48",
  "2001:4860:4801:49",
  "2001:4860:4801:4a",
  "2001:4860:4801:50",
  "2001:4860:4801:51",
  "2001:4860:4801:53",
  "2001:4860:4801:60",
  "2001:4860:4801:61",
  "2001:4860:4801:62",
  "2001:4860:4801:63",
  "2001:4860:4801",
  "2001:4860:4801:64",
  "2001:4860:4801:65",
  "2001:4860:4801:66",
  "2001:4860:4801:67",
  "2001:4860:4801:68",
  "2001:4860:4801:69",
  "2001:4860:4801:6a",
  "2001:4860:4801:6b",
  "2001:4860:4801:6c",
  "2001:4860:4801:6d",
  "2001:4860:4801:6e",
  "2001:4860:4801:6f",
  "2001:4860:4801:70",
  "2001:4860:4801:71",
  "2001:4860:4801:72",
  "2001:4860:4801:73",
  "2001:4860:4801:74",
  "2001:4860:4801:75",
  "2001:4860:4801:76",
  "2001:4860:4801:77",
  "2001:4860:4801:80",
  "2001:4860:4801:81",
  "2001:4860:4801:82",
  "2001:4860:4801:83",
  "2001:4860:4801:84",
  "2001:4860:4801:85",
  "2001:4860:4801:86",
  "2001:4860:4801:90",
  "2001:4860:4801:91",
  "2001:4860:4801:c",
  "2001:4860:4801:f",
  "66.249.64.0",
  "66.249.64.128",
  "66.249.64.160",
  "66.249.64.192",
  "66.249.64.224",
  "66.249.64.32",
  "66.249.64.64",
  "66.249.64.96",
  "66.249.65.0",
  "66.249.65.128",
  "66.249.65.160",
  "66.249.65.192",
  "66.249.65.224",
  "66.249.65.32",
  "66.249.65.64",
  "66.249.65.96",
  "66.249.66.0",
  "66.249.66.128",
  "66.249.66.192",
  "66.249.66.32",
  "66.249.66.64",
  "66.249.68.0",
  "66.249.68.32",
  "66.249.68.64",
  "66.249.69.0",
  "66.249.69.128",
  "66.249.69.160",
  "66.249.69.192",
  "66.249.69.224",
  "66.249.69.32",
  "66.249.69.64",
  "66.249.69.96",
  "66.249.70.0",
  "66.249.70.128",
  "66.249.70.32",
  "66.249.70.64",
  "66.249.70.96",
  "66.249.71.0",
  "66.249.71.128",
  "66.249.71.160",
  "66.249.71.192",
  "66.249.71.32",
  "66.249.71.64",
  "66.249.71.96",
  "66.249.72.0",
  "66.249.72.128",
  "66.249.72.160",
  "66.249.72.192",
  "66.249.72.224",
  "66.249.72.32",
  "66.249.72.64",
  "66.249.72.96",
  "66.249.73.0",
  "66.249.73.128",
  "66.249.73.160",
  "66.249.73.192",
  "66.249.73.224",
  "66.249.73.32",
  "66.249.73.64",
  "66.249.73.96",
  "66.249.74.0",
  "66.249.74.32",
  "66.249.74.64",
  "66.249.75.0",
  "66.249.75.128",
  "66.249.75.160",
  "66.249.75.192",
  "66.249.75.224",
  "66.249.75.32",
  "66.249.75.64",
  "66.249.75.96",
  "66.249.76.0",
  "66.249.76.128",
  "66.249.76.160",
  "66.249.76.192",
  "66.249.76.224",
  "66.249.76.32",
  "66.249.76.64",
  "66.249.76.96",
  "66.249.77.0",
  "66.249.77.32",
  "66.249.77.64",
  "66.249.79.0",
  "66.249.79.128",
  "66.249.79.160",
  "66.249.79.192",
  "66.249.79.224",
  "66.249.79.32",
  "66.249.79.64",
  "66.249.79.96",
]

/* 是否 google ip */
export const checkIsGoogleBotIp = (ip: string) => googleBotIps.includes(ip)